import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectableItemComponent } from './selectable-item/selectable-item.component';
import { SelectableRadioComponent } from './selectable-radio.component';

@NgModule({
  declarations: [
    SelectableRadioComponent,
    SelectableItemComponent
  ],
  imports: [CommonModule,],
  exports: [
    SelectableItemComponent,
    SelectableRadioComponent
  ],
})
export class SelectableRadioModule { }
